module.exports = __webpack_public_path__ + "static/media/aries.d158f960.svg";